import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const keyPrefix = 'user_details_general_info';
export const useUserDetailsGeneralInfoTranslation = (): UseTranslationResponse<'widgets', typeof keyPrefix> => useTranslation('widgets', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    title: 'Общая информация',
    full_name: 'Имя',
    email: 'Email',
    password: 'Пароль',
    role: 'Роль',
    create_time: 'Создано',
    update_time: 'Изменено',
    user_id: 'ID пользователя',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    title: 'General information',
    full_name: 'Name',
    email: 'Email',
    password: 'Password',
    role: 'Role',
    create_time: 'Created',
    update_time: 'Updated',
    user_id: 'User ID',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    title: 'Información general',
    full_name: 'Nombre',
    email: 'Correo electrónico',
    password: 'Contraseña',
    role: 'Rol',
    create_time: 'Creado',
    update_time: 'Modificado',
    user_id: 'ID de usuario',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    title: 'Informações gerais',
    full_name: 'Nome',
    email: 'E-mail',
    password: 'Senha',
    role: 'Função',
    create_time: 'Criado',
    update_time: 'Alterado',
    user_id: 'ID do usuário',
  },
}) as Record<string, unknown>;
